import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/info.svg';

export const IconInfo: IconComponent = props => <Icon {...props} src={src} />;
